import { GameVars } from "../GameVars";
import { RectangleWithRadius } from "../utils/RectangleWithRadius";
import { GameConstants } from "../GameConstants";

export class ReusableMenuBackground extends Phaser.Group {

    public static PREMATCH_LAYER = "prematch layer";
    public static PAUSE_LAYER = "pause layer";
    public static RESULT_SCENE = "result scene";

    private static PLAYER_FLAG_PX = 175;

    private backgroundType: string;
    private tournamentData: TournamentData;
    private penaltyLabel: Phaser.Text;
    private extraTimeLabelsContainer: Phaser.Group;
    private extraTimeLabelTimerEvent: Phaser.TimerEvent;
    private playerGoals: number;
    private resultLabel: Phaser.Text;
    private adversaryGoalsBlackLabel: Phaser.Text;
    private adversaryGoalsRedLabel: Phaser.Text;

    constructor(game: Phaser.Game, backgroundType: string) {

        super(game, null, "reusable-menu-background", false);

        this.extraTimeLabelTimerEvent = null;

        this.backgroundType = backgroundType;
        this.tournamentData = GameVars.tournamentData;

        if (this.backgroundType === ReusableMenuBackground.RESULT_SCENE) {
            this.playerGoals = 0;
        } else {
            this.playerGoals = GameVars.playerGoals;
        }

        let height: number;
        let upperRectangleConfiguration: string;

        if (this.backgroundType === ReusableMenuBackground.PREMATCH_LAYER) {
            height = 710;
            upperRectangleConfiguration = RectangleWithRadius.TOP_CONFIGURATION;
        } else if (this.backgroundType === ReusableMenuBackground.RESULT_SCENE) {
            upperRectangleConfiguration = RectangleWithRadius.TOP_CONFIGURATION;
            height = 375;
        } else if (this.backgroundType === ReusableMenuBackground.PAUSE_LAYER) {
            height = 510;
            upperRectangleConfiguration = RectangleWithRadius.TOP_CONFIGURATION;
        }

        let upperRectangleWithRadius: RectangleWithRadius = new RectangleWithRadius(this.game, 20, 20, 768 - 40, height, 40,
            "#ffffff", 0.5, upperRectangleConfiguration);
        this.add(upperRectangleWithRadius);

        this.addUpperStripe();
        this.addFlags();
        this.addLabels();
    }

    public destroy(destroyChildren?: boolean, soft?: boolean): void {

        if (this.extraTimeLabelTimerEvent !== null) {
            this.extraTimeLabelTimerEvent.pendingDelete = true;
        }

        super.destroy(destroyChildren, soft);
    }

    public onCoinAdded(): void {

        this.updateScoreLabel();
    }

    public updateScoreLabelOnPauseMenu(): void {

        let fontColor: string;

        if (GameVars.playerGoals > GameVars.adversaryGoals) {
            fontColor = "#2bb740";
        } else if (GameVars.playerGoals === GameVars.adversaryGoals) {
            fontColor = "#FF7505";
        } else {
            fontColor = "#D8102D";
        }

        this.resultLabel.text = GameVars.playerGoals.toString() + "-" + GameVars.adversaryGoals.toString();
        this.resultLabel.setStyle({ font: "115px futura-bold", fill: fontColor });
        this.resultLabel.setShadow(3, 3, "rgba(0,0,0,1)", 0);

        if (this.resultLabel.text.length > 3) {
            this.resultLabel.fontSize = 95;
        }
    }

    private addUpperStripe(): void {

        // la franja de arriba
        const stripeContainer = new Phaser.Group(this.game);
        stripeContainer.y = 70;
        this.add(stripeContainer);

        const blackGradientRectangle = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData("dark_gradient"));
        blackGradientRectangle.scale.setTo(58, 1.7);
        stripeContainer.add(blackGradientRectangle);

        const trophyImage = new Phaser.Image(this.game, 25, 30, "texture_atlas_2", this.tournamentData.trophyImageName);
        trophyImage.anchor.setTo(0, .5);
        stripeContainer.add(trophyImage);

        const trophyLabel = new Phaser.Text(this.game, 145, this.tournamentData.titleLabel_py, " " + this.tournamentData.name + " ", { font: this.tournamentData.titleLabelFontSize + "px whoopass", fill: "#DAE9E9" });
        stripeContainer.add(trophyLabel);
    }

    private addFlags(): void {

        const playerFlag_px = ReusableMenuBackground.PLAYER_FLAG_PX;
        const adversaryFlag_px = 768 - ReusableMenuBackground.PLAYER_FLAG_PX;
        const flag_py = 260;

        const greenBasis = new Phaser.Image(this.game, playerFlag_px, flag_py, "texture_atlas_5", "green-basis");
        greenBasis.scale.set(1.1);
        greenBasis.anchor.set(.5);
        this.add(greenBasis);

        const redBasis = new Phaser.Image(this.game, adversaryFlag_px, flag_py, "texture_atlas_5", "red-basis");
        redBasis.scale.set(1.1);
        redBasis.anchor.set(.5);
        this.add(redBasis);

        const playerTeamID = GameVars.playerID;
        const playerFlagImageName = "bandera_" + GameVars.formatNumberForTextureAtlas(playerTeamID);

        const playerFlag = new Phaser.Image(this.game, playerFlag_px, flag_py + 5, "texture_atlas_5", playerFlagImageName);
        playerFlag.scale.set(1.25);
        playerFlag.anchor.set(.5);
        this.add(playerFlag);

        const adversaryTeamID: number = GameVars.adversaryID;
        const adversaryFlagImageName: string = "bandera_" + GameVars.formatNumberForTextureAtlas(adversaryTeamID);

        const adversaryFlag = new Phaser.Image(this.game, adversaryFlag_px, flag_py + 5, "texture_atlas_5", adversaryFlagImageName);
        adversaryFlag.scale.set(1.25);
        adversaryFlag.anchor.set(.5);
        this.add(adversaryFlag);
    }

    private addLabels(): void {

        var gameText: any = GameVars.gameText;

        var resultString: string;
        var colorFont: string;

        if (this.backgroundType === ReusableMenuBackground.PREMATCH_LAYER) {

            const vsLabel = new Phaser.Text(this.game, GameConstants.GAME_WIDTH / 2, 226,
                gameText.VS, { font: "50px Ubuntu", fontWeight: "700", fill: "#000000", align: "center" });
            vsLabel.x -= vsLabel.width / 2;
            this.add(vsLabel);

        } else {

            // el resultado del partido
            resultString = "" + this.playerGoals + "-" + GameVars.adversaryGoals;

            if (GameVars.playerGoals > GameVars.adversaryGoals) {
                colorFont = "#2bb740";
            } else if (GameVars.playerGoals === GameVars.adversaryGoals) {
                colorFont = "#FF7505";
            } else {
                colorFont = "#D8102D";
            }

            this.resultLabel = new Phaser.Text(this.game, GameConstants.GAME_WIDTH / 2, 190, resultString, { font: "115px futura-bold", fill: colorFont });
            this.resultLabel.anchor.x = .5;
            this.resultLabel.setShadow(3, 3, "rgba(0,0,0,1)", 0);
            if (this.resultLabel.text.length > 3) {
                this.resultLabel.fontSize = 95;
            }
            this.add(this.resultLabel);
        }

        // etiquetas con los nombres de los equipos
        const playerData: TeamData = GameVars.getPlayerData();
        const adversaryData: TeamData = GameVars.getAdversaryData();

        // pasar a ubuntu condensed
        const teamNameLabelStyle = { font: "34px Ubuntu Condensed", fill: "#000000", align: "center" };

        const playerLabel = new Phaser.Text(this.game, ReusableMenuBackground.PLAYER_FLAG_PX, 316, playerData.name, teamNameLabelStyle);
        playerLabel.scale.setTo(.8, 1);
        playerLabel.x -= playerLabel.width / 2;
        this.add(playerLabel);

        const adversaryLabel = new Phaser.Text(this.game, 768 - ReusableMenuBackground.PLAYER_FLAG_PX, 316, adversaryData.name, teamNameLabelStyle);
        adversaryLabel.scale.setTo(.8, 1);
        adversaryLabel.x -= adversaryLabel.width / 2;
        this.add(adversaryLabel);

        if (this.backgroundType !== ReusableMenuBackground.RESULT_SCENE) {

            // a white stripe behind
            const whiteStripe = new Phaser.Sprite(this.game, 20, 365, this.game.cache.getBitmapData("white_square"));
            whiteStripe.scale.setTo(45.5, 3);
            whiteStripe.alpha = .35;
            this.add(whiteStripe);

            const matchTypeLabel = new Phaser.Text(this.game, GameConstants.GAME_WIDTH / 2, 362,
                GameVars.getMatchName(), { font: "42px Ubuntu", fill: "#888888", align: "center" });
            matchTypeLabel.x -= matchTypeLabel.width / 2;
            this.add(matchTypeLabel);
        }

        // etiqueta con los goles a marcar
        if (this.backgroundType === ReusableMenuBackground.PREMATCH_LAYER) {

            // ETIQUETAS PARPADEANTS
            this.adversaryGoalsBlackLabel = new Phaser.Text(this.game, 0, 420,
                (GameVars.adversaryGoals + 1).toString() + " GOALS", { font: "50px Ubuntu", fill: "#000000", align: "center" });
            this.add(this.adversaryGoalsBlackLabel);

            this.adversaryGoalsRedLabel = new Phaser.Text(this.game, 0, 420,
                (GameVars.adversaryGoals + 1).toString() + " GOALS", { font: "50px Ubuntu", fill: "#D8102D", align: "center" });
            this.adversaryGoalsRedLabel.visible = false;
            this.add(this.adversaryGoalsRedLabel);

            var adversaryGoalsLabel_px = 405 - this.adversaryGoalsBlackLabel.width;

            this.adversaryGoalsBlackLabel.x = adversaryGoalsLabel_px;
            this.adversaryGoalsRedLabel.x = adversaryGoalsLabel_px;

            this.game.time.events.loop(400, function (): void {

                this.adversaryGoalsRedLabel.visible = !this.adversaryGoalsRedLabel.visible;
                this.adversaryGoalsBlackLabel.visible = !this.adversaryGoalsBlackLabel.visible;

            }, this);

            var toWinLabel: Phaser.Text = new Phaser.Text(this.game,
                425, 430, "TO WIN", { font: "38px Ubuntu Condensed", fill: "#000000", align: "center" });
            toWinLabel.scale.setTo(.8, 1);
            this.add(toWinLabel);
        }

        if (GameVars.penalties) {

            const penaltyLabel_py = 186;

            if (GameVars.penaltyScored) {
                this.penaltyLabel = new Phaser.Text(this.game, GameConstants.GAME_WIDTH / 2, penaltyLabel_py, "+penalty", { font: "35px Ubuntu", fill: "#006400", align: "center" });
                this.game.time.events.loop(250, function (): void {
                    this.penaltyLabel.visible = !this.penaltyLabel.visible;
                }, this);
            } else {

                this.penaltyLabel = new Phaser.Text(this.game, GameConstants.GAME_WIDTH / 2, penaltyLabel_py, "+penalty", { font: "35px Ubuntu", fill: "#000000", align: "center" });
                this.penaltyLabel.alpha = .4;
            }

            this.penaltyLabel.anchor.x = .5;
            this.add(this.penaltyLabel);
        }

        if (GameVars.isTimedLevel && this.backgroundType === ReusableMenuBackground.PREMATCH_LAYER) {

            // una etiqueta parpadeante con el tiempo
            const time = GameVars.time;

            this.extraTimeLabelsContainer = new Phaser.Group(this.game);
            this.extraTimeLabelsContainer.x = 185;
            this.extraTimeLabelsContainer.y = 390;
            this.extraTimeLabelsContainer.angle = -12;
            this.add(this.extraTimeLabelsContainer);

            var extraTimeImage = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "msg-extra-time");
            extraTimeImage.anchor.setTo(.5);
            extraTimeImage.scale.setTo(1.25);
            this.extraTimeLabelsContainer.add(extraTimeImage);

            let timeLabel = new Phaser.Text(this.game, 0, 80, "" + time + "S ", { font: " 70px whoopass", fill: "#DAE9E9" });
            timeLabel.x -= timeLabel.width * .5;
            timeLabel.setShadow(2, 2, "rgba(0,0,0,1)", 0);
            this.extraTimeLabelsContainer.add(timeLabel);

            this.extraTimeLabelTimerEvent = this.game.time.events.loop(650,
                function (): void {
                    this.extraTimeLabelsContainer.visible = !this.extraTimeLabelsContainer.visible;
                }, this);
        }
    }

    private updateScoreLabel(): void {

        this.playerGoals++;

        this.resultLabel.text = this.playerGoals.toString() + "-" + GameVars.adversaryGoals;

        if (this.resultLabel.text.length > 3) {
            this.resultLabel.fontSize = 100;
        }
    }
}
